import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const NaturalMatingIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path
        d="M13.69,7.91a4.5,4.5,0,1,0-4.77,5.72A6.51,6.51,0,0,1,13.69,7.91Z"
        fill="transparent"
      />
      <path d="M11,13.38A4.51,4.51,0,0,0,13.81,10,4.51,4.51,0,0,0,11,13.38Z" fill="transparent" />
      <path
        d="M15.86,9.73a6.5,6.5,0,0,1-4.77,5.72A4.45,4.45,0,0,0,12,17.16a4.49,4.49,0,1,0,3.85-7.42Z"
        fill="transparent"
      />
      <path d="M15.71,7.7a6.44,6.44,0,0,0-.87-2l2.27-2.27.42.42a.53.53,0,0,0,.9-.36L18.5,1.1A.53.53,0,0,0,18,.56L15.62.63a.53.53,0,0,0-.36.9l.43.43L13.5,4.15A6.5,6.5,0,1,0,9.08,15.66a6.26,6.26,0,0,0,.87,2L8.89,18.76l-.66-.66A.89.89,0,0,0,7,18.1l-.16.16a.89.89,0,0,0,0,1.26l.66.66-.66.66a.89.89,0,0,0,0,1.26l.16.16a.89.89,0,0,0,1.26,0l.66-.66.66.66a.89.89,0,0,0,1.26,0L11,22.1a.89.89,0,0,0,0-1.26l-.66-.66,1-1a6.49,6.49,0,0,0,10.61-5A6.43,6.43,0,0,0,15.72,7.7ZM6,12.15a4.49,4.49,0,1,1,7.68-4.24,6.5,6.5,0,0,0-4.77,5.72A4.49,4.49,0,0,1,6,12.15ZM13.81,10A4.49,4.49,0,0,1,11,13.38,4.49,4.49,0,0,1,13.81,10Zm1.58,8.7A4.52,4.52,0,0,1,12,17.15a4.38,4.38,0,0,1-.92-1.71,6.5,6.5,0,0,0,4.77-5.72,4.49,4.49,0,0,1-.47,9Z" />
    </SvgIcon>
  )
}
export default NaturalMatingIcon
